import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, reviewCount, showCount = true, size = "sm" }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.3; // Show half star if decimal is 0.3 or higher
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  // Size configurations
  const sizeConfig = {
    xs: { star: 'w-3 h-3', text: 'text-xs' },
    sm: { star: 'w-4 h-4', text: 'text-sm' },
    md: { star: 'w-5 h-5', text: 'text-base' },
    lg: { star: 'w-6 h-6', text: 'text-lg' }
  };

  const config = sizeConfig[size] || sizeConfig.sm;

  return (
    <div className="flex items-center gap-2 bg-yellow-50 dark:bg-yellow-900/30 px-2 py-1 rounded-full">
      <div className="flex items-center gap-0.5">
        {/* Full Stars */}
        {Array.from({ length: fullStars }).map((_, index) => (
          <Star
            key={`full-${index}`}
            className={`${config.star} fill-yellow-500 text-yellow-500`}
          />
        ))}

        {/* Half Star - Using simpler overlay approach */}
        {hasHalfStar && (
          <div className="relative inline-block">
            {/* Empty star (background) */}
            <Star
              className={`${config.star} text-gray-300 dark:text-gray-600`}
            />
            {/* Half filled star (overlay) */}
            <div className="absolute top-0 left-0 overflow-hidden" style={{ width: '50%' }}>
              <Star
                className={`${config.star} fill-yellow-500 text-yellow-500`}
              />
            </div>
          </div>
        )}

        {/* Empty Stars */}
        {Array.from({ length: emptyStars }).map((_, index) => (
          <Star
            key={`empty-${index}`}
            className={`${config.star} text-gray-300 dark:text-gray-600`}
          />
        ))}
      </div>

      {/* Rating Number and Count */}
      {showCount && (
        <>
          <span className={`${config.text} font-bold text-yellow-700 dark:text-yellow-400`}>
            {rating.toFixed(1)}
          </span>
          <span className={`text-xs text-gray-600 dark:text-gray-400`}>
            ({reviewCount || 0})
          </span>
        </>
      )}
    </div>
  );
};

export default StarRating;
